export enum ContentType {
  BlogPost = "blog-post",
  Case = "case",
  LandingPage = "landing-page",
  Page = "page"
}